import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import DonationData from './DonationData';
import DonorData from './DonorData';
import PatientData from './PatientData';
import moment from 'moment';
import AddressData from './AdressData';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import { lookups } from '../../libs/services';

import {preOffersFields, preOffersNextNumber, preOffers, preOffersSave, donationRules} from '../../libs/services';

var Config = require('../../config');

class ModalNew extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
        this.save = this.save.bind(this);
		this.showField = this.showField.bind(this);
		this.getDonorData = this.getDonorData.bind(this);
		this.validBirthdate = this.validBirthdate.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.getDonationType = this.getDonationType.bind(this);
		this.getInfo = this.getInfo.bind(this);
		this.updateStateDonor = this.updateStateDonor.bind(this);
		this.formatBirthday = this.formatBirthday.bind(this);
		this.getInfoPatient = this.getInfoPatient.bind(this);
		this.handleChangeCompleteDate=this.handleChangeCompleteDate.bind(this)
		this.state = {
			show: false,
            donation_types:[],
			patient_person_id:null,
			configuredFields:{
				offer:[],
				donor:[],
				patient:[]
			},
			folio:"",
			sex:"",
			civil_status:"",
			names:"",
			lastname1:"",
			lastname2:"",
			timestamp_date:"",
			street:"",
			no_ext:"",
			colonia:"",
			birthday:"",
			relationship:"",
			flagEdit: false,
			preOfferId: null,
			personDonorId:null,
			personPatientId:null,
			state:"",
			addressId:null,
            ext:"",
            phone_number:"",
            phone_type:"CELULAR",
			phonesAdded:[],
			isLoading:false,
			optionsDonor:[],
			loading_patient:false,
			patient_list:[],
			national_center_id:"",
			jobProfiles:[],
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null);
	}

	handleClose() {
		this.setState({ 
			show: false,
			timestamp_date: "",
			timestamp_hour: "",
			document_number:"",
			email:"",
			folio:"",
			flagEdit: false,
			preOfferId:null,
			sex:"",
			civil_status:"",
			birthday:"",
			relationship:"",
			personDonorId:null,
			personPatientId:null,
			state:"",
			street:"",
			no_ext:"",
			colonia:"",
			names:"",
			lastname1:"",
			lastname2:"",
			patient_name:"",
			patient_lastname1:"",
			patient_lastname2:"",
			patient_sex:"",
			patient_birthday:"",
			social_number:"",
			rh_group:"",
			relationship:"",
			national_name:"",
			indice:-1,
			requestedSelected:[],
			ext:"",
            phone_number:"",
            phone_type:"",
			phonesAdded:[],
			donation_type_id:"",
			show_patient_data:false,
			document_number:"",
			age:"",
			scholarship:"",
			postal_code:"",
			emergency_level:"",
			national_center:[],
			national_center_id:"",
		});
	}

	async handleShow(timestamp_date, hour, preOfferId) {
		await this.setState({
			show: true,
			timestamp_date: timestamp_date,
			timestamp_hour: hour,
			document_number:"",
			email:"",
			folio:"",
			flagEdit: (preOfferId !== null && preOfferId !== undefined)?true:false,
			preOfferId:preOfferId,
			sex:"",
			civil_status:"",
			birthday:"",
			no_ext:"",
			colonia:"",
			relationship:"",
			personDonorId:null,
			personPatientId:null,
			state:"",
			names:"",
			lastname1:"",
			lastname2:"",
			convoke_places_id:this.props.convoke_place,
			donation_type_extraction_id: this.props.extraction_type,
			requestedSelected:[],
			national_center:[],
			national_center_id:"",
		});	
		response = await lookups('profession', 'false');
        if(response !== undefined){
            this.setState({
                jobProfiles: response
            });
        }
		this.extractionTypeSelected(null,"id",{target:{name:"donation_type_extraction_id", value:this.props.extraction_type}})

		var response = await preOffersFields(this.props.convoke_place, this.props.extraction_type);
		if(response !== undefined){
			this.setState({
				configuredFields: response,phone_type:'CELULAR'
		    });

		}		

		if(!this.state.flagEdit){
			response = await preOffersNextNumber(timestamp_date);

			if(response !== undefined){
				this.setState({
					folio: response
				});
			}
			
		}else{
			response = await preOffers(preOfferId);

			if(response !== null && response !== undefined){

				if(response.pre_offers.donation_type_extraction_id !== null 
					&& response.pre_offers.donation_type_extraction_id !== undefined
					&& response.pre_offers.donation_type_extraction_id !== ""){
					await this.getDonationType(response.pre_offers.donation_type_extraction_id);
				}
				//show_patient_data
				var auxDate = new Date(response.person.birthday);
				var stringDate = ("0" + auxDate.getDate()).slice(-2)+'/'+("0" + (auxDate.getMonth() + 1)).slice(-2)+'/'+auxDate.getFullYear();
				const result = this.state.donation_types.find(item => item.donation_type.id === response.pre_offers.donation_type_id);
				if (result!=null || result!= undefined) {
					if (result.donation_type.patient_required === 1) { 
						this.setState({
							show_patient_data: true
						})
					}
				}			
				await this.setState({
					folio: response.pre_offers.folio,
					timestamp_hour:moment(response.pre_offers.timestamp_hour, 'H:mm:ss').format('HH:mm'),
					timestamp_date:moment(response.pre_offers.timestamp_date).format('YYYY-MM-DD'),
					convoke_places_id: response.pre_offers.convoke_places_id,
					donation_type_extraction_id: response.pre_offers.donation_type_extraction_id,
					donation_type_id: response.pre_offers.donation_type_id,
					document_type: response.documents.length > 0? response.documents[0].document_type:null,
					document_number: response.documents.length > 0? response.documents[0].document_number:null,
					sex: response.person.sex,
					civil_status: response.person.civil_status,
					birthday: response.person.birthday !== null? stringDate:"",
					age: response.pre_offers.donor_age,
					names: response.person.names,
					lastname1: response.person.lastname1,
					lastname2: response.person.lastname2,
					email: response.person.email,
					scholarship: response.person.scholarship,
					job_profile: response.person.job_profile,
					national_center_id: response.pre_offers.national_center_id,
					national_name: response.pre_offers.patient_section_name,
					relationship: response.pre_offers.patient_relationship,
					emergency_level: response.pre_offers.emergency_level,
					personDonorId: response.pre_offers.person_donor_id,
					personPatientId: response.pre_offers.person_patient_id ,
					addressId: response.address !== null? response.address.id:null,
					street: response.address !== null? response.address.street:null,
					no_ext: response.address !== null ? response.address.ext_num: "",
					colonia: response.address !== null ? response.address.colonia: "",
					mpio: response.address !== null? response.address.municipio:null,
					postal_code: response.address !== null? response.address.postal_code:null,
					state: response.address !== null? response.address.state:null,
					phone_type: response.phones.length >0 ? response.phones[0].type:null,
					phone_number : response.phones.length > 0 ? response.phones[0].number:null,
					ext: response.phones.length > 0 ? response.phones[0].extension:null

				});

				if(response.address !== null){
					this.address.getMpios(response.address.estado,response.address.municipio);
				}

				this.donor_data.setJobProfile(response.person.job_profile);
				if(response.person1 !== null && response.person1 !== undefined){
					var auxDate = new Date(response.person1.birthday);
					var stringDate = ("0" + auxDate.getDate()).slice(-2)+'/'+("0" + (auxDate.getMonth() + 1)).slice(-2)+'/'+auxDate.getFullYear();

					this.setState({
						patient_name: response.person1.names,
						patient_lastname1: response.person1.lastname1,
						patient_lastname2: response.person1.lastname2,
						patient_sex: response.person1.sex,
						patient_birthday: stringDate,
						social_number: response.person1.social_number
					});

					if (response.person1.lookup_group !== "" && response.person1.lookup_rh !== "") {
						this.setState({
							lookup_group:response.person1.lookup_group,
							lookup_rh:response.person1.lookup_rh,
							rh_group: response.person1.lookup_group + (
								response.person1.lookup_rh === 'POSITIVO' ? ' +' :
								response.person1.lookup_rh === 'NEGATIVO' ? ' -' : ''
							)
						});
					}else{
						this.setState({ rh_group: "" });
					}

					if(this.state.national_center_id !== ""){
						//this.patient_data.setNationalCenter(this.state.national_center_id);
					}
				}
			}
			
		}
	}
	async getDonationType(id){
		var response = await donationRules(id);
		if(response !== undefined){
			this.setState({ donation_types: response });
		}
	}
    
	//Evento de cambio en elementos formulario
	handleChange = (event) => {
		if(event.target.value.length <= 500){
			this.setState({[event.target.name]: event.target.value});	
		}
	}

    async save(){
		console.log("aqui")
		if (this.isValidForm()) {
			var flagPatientDataRequired = false;
			var patientFieldsCounter = 0;

			var preOffer = {
				folio: this.state.folio,
				timestamp_date: this.state.timestamp_date,
				timestamp_hour: this.state.timestamp_hour,
				convoke_places_id: this.state.convoke_places_id,
				donation_type_extraction_id: this.state.donation_type_extraction_id,
				donation_type_id: this.state.donation_type_id,
				donor_age: this.state.age,
				national_center_id: this.state.national_center_id,
				patient_section_name: this.state.national_name,
				patient_relationship: this.state.relationship,
				emergency_level: this.state.emergency_level,
				health_facilities_id: sessionStorage.getItem("health_facilities_id"),
				person_donor_id:this.state.personDonorId!=null?this.state.personDonorId:0,
				person_patient_id:this.state.personPatientId,
			};
			preOffer.person = await this.getDonorData();
			if (this.state.phone_number!="") {
				var obj = {};
              obj.type = this.state.phone_type;
              obj.number = this.state.phone_number;
              obj.extension = this.state.ext;
			  obj.person_id = preOffer.person.id;
			  preOffer.person.phones = [];
			  preOffer.person.phones.push(obj);
			}
			
			if(this.state.configuredFields.patient.length > 0){
				if(this.state.show_patient_data){
					preOffer.person1 = await this.getPatientData();
					preOffer.person1.address_id=this.state.personAddressId;
					for (const [key, value] of Object.entries(preOffer.person1)) {
						if(value!== undefined && value !== null && value !== "" &&  key !== "person_type"){
							flagPatientDataRequired = true;
							patientFieldsCounter++;
						}
					}

					if(flagPatientDataRequired){
						if(preOffer.person1.names === undefined || preOffer.person1.names === null || preOffer.person1.names === ""
						|| preOffer.person1.lastname1 === undefined || preOffer.person1.lastname1 === null
						|| preOffer.person1.lastname1 === ""){
							swal('Error', 'Ingresar nombre y apellido paterno del paciente', 'error');
							return;
						}
					}

					if(patientFieldsCounter === 0){
						delete preOffer.person1;
					}
				}				
			}

			if(this.state.flagEdit){
				preOffer.id = this.state.preOfferId;
				preOffer.person_donor_id = this.state.personDonorId;
				preOffer.person_patient_id = this.state.personPatientId;
				preOffer.person.id = this.state.personDonorId;
				if(preOffer.person1 !== undefined){
					preOffer.person1.id = this.state.personPatientId;
				}
			}

			if(this.validBirthdate()){
				var response = await preOffersSave(this.state.flagEdit, this.state.preOfferId, preOffer, this.props.waiting);

				if(response !== undefined){
					swal('Proceso correcto','Registro Guardado','success');
					this.props.getList("all", "00:00","23:59");
					this.handleClose();
				}else{
					swal('Error', 'No se pudo guardar', 'error');
				}
				
			}else{
				swal('Error', 'La Fecha de Nacimiento no puede ser mayor a la fecha de hoy', 'error');
			}
		} else {
			swal('Error', 'Campos incompletos', 'error');
		}
    }

	//Verificar si el formulario es valido
	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if(control !== null){
			if(control.value === ""){
				control.classList.add('error');
				res = false;

				return res;
			}else{
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}

				res = true;
			} 

		}
		
		return res;
	}

	validBirthdate(){
		var aux_date = new Date();
		var hoy = aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2);
		hoy = moment(hoy);
		var birth = moment(this.state.birthday,'DD-MM-YYYY');
		var date_ok = true;

		if(hoy !== 'Invalid date' && birth !== 'Invalid date'){
			if(hoy < birth){
				date_ok = false;
			}
		}else{
			date_ok = false;
		}		

		return date_ok;

	}

	async getDonorData(){
		var documents = [];
		var person = {
			person_type: 'donor',
			sex: this.state.sex,
			civil_status: this.state.civil_status,
			birthday:  this.state.birthday !== undefined? 
					this.state.birthday.split(/\//).reverse().join('/')
					:null,
			names: this.state.names,
			lastname1: this.state.lastname1,
			lastname2: this.state.lastname2,
			email: this.state.email,
			scholarship: this.state.scholarship,
			job_profile: this.state.job_profile,
			//id: this.state.personDonorId!=null?this.state.personDonorId:null,
		};
		if (this.state.personDonorId!=null) {
			person.id= this.state.personDonorId
		}
		var doc = {
			document_type: this.state.document_type,
			document_number: this.state.document_number
		};
		if(doc.document_type !== "" && doc.document_type !== null && doc.document_type !== undefined){
			documents.push(doc);
			person.documents = documents;
		}

		person.address = {
			street: this.state.street,
			postal_code: this.state.postal_code,
			municipio: this.state.mpio,
			estado: this.state.state,
			ext_num:this.state.no_ext,
			colonia:this.state.colonia,
			//id:this.state.addressId!=null?this.state.address:null
		};
		if (this.state.addressId!=null) {
			person.address.id=this.state.addressId
		}
		if(this.state.addressId !== null){
			person.address_id = this.state.addressId;
			person.address.id = this.state.addressId;
		}

		return person;
	}

	async getPatientData(){
		var patient = {
			names: this.state.patient_name,
			lastname1: this.state.patient_lastname1,
			lastname2: this.state.patient_lastname2,
			sex: this.state.patient_sex,
			birthday: this.state.patient_birthday !== undefined?
				this.state.patient_birthday.split(/\//).reverse().join('/')
				:null,
			social_number: this.state.social_number,
			lookup_group: this.state.lookup_group,
			lookup_rh: this.state.lookup_rh,
			person_type: 'patient',
			//id:this.state.personPatientId!=null?this.state.personPatientId:null,
		};
		if (this.state.personPatientId!=null) {
			patient.id=this.state.personPatientId
		}
		return patient;
	}

	selectFieldHandle = (id, name, event, index, value) => {
		this.setState({[event.target.name]:event.target.value});

		if(event.target.name === "donation_type_id"){
			if(this.state.patient_person_id === ""){
				if(this.patient !== undefined && this.patient !== null){
					
					setTimeout(()=>{
						if(this.patient!== null){
							this.patient.refs._handleSearch._instance.clear();	
						}
						
					}, 500);
					
				}
				this.clearPatientSearch();
			}
		}

		if(event.target.id !== null){
	        var control = document.getElementById(event.target.id);
	        if(control !== null){
	        	if(control.required){
	        		if(event.target.value!==""){
	        			if(control.className.includes('error')){
	        				 control.classList.remove('error');
	        			}
	        		}
	        	}else{
	        		if(event.target.value!==""){
	        			if(control.className.includes('error')){
	        				 control.classList.remove('error');
	        			}
	        		}
	        	}
	        }
	    }
	}

	autocompleteHandle = (name,value) => {
		this.setState({[name]:value});
	}

	extractionTypeSelected = async (id, name, event, index, value) => {
		this.selectFieldHandle("id","donation_type_extraction_id",event, index, event.target.value);
		
		this.setState({donation_types:[]});
		
		var response = await donationRules(event.target.value);

		if(response !== undefined){
			this.setState({
                donation_types: response
            });
		}        
        
	}

    donationTypeSelected = (id, name, event, index, value) => {
		this.selectFieldHandle("id","donation_type_id",event, index, event.target.value);

		for(var i=0; i < this.state.donation_types.length;i++){
			if(parseInt(this.state.donation_types[i].donation_type.id,10) === parseInt(event.target.value,10)){
				if(this.state.donation_types[i].donation_type.patient_required===1){//La donacion requiere paciente
					if(this.state.patient_person_id === "" || this.state.patient_person_id === null){
						this.state.show_patient_data= true;
					}
				}else{
					this.state.show_patient_data = false;
				}
			}
		}
	
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);
      		if(form.elements[index + 1] !== undefined){

      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null)
    					form.elements[index + 1].focus();
    			
    				else if(form.elements[index + 1].getAttribute("disabled") === "")
    					form.elements[index + 2].focus();
    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

	showField(section, fieldKey){
		var result = this.state.configuredFields[section].find(obj => {
			return obj.key.toLowerCase() === fieldKey.toLowerCase()
		});

		if(result !== null && result !== undefined){
			return true;
		}	
		return false;
	}

	dateHandleChange = (event) => {

		if(event.target.id === "birthday"){
			this.setState({ birthday: event.target.value});
			
			var control = document.getElementById(event.target.id);
			if(event.target.value.length === 10){
				control.classList.remove('error');
				this.calcularEdad(event.target.value,control);
			}else{
				control.classList.add('error');
			}
		}else{
			this.setState({ patient_birthday: event.target.value});
		}
	}

	//calcular edad
	calcularEdad(fecha,control){
		var hoy = new Date();
	    var cumpleanos = new Date(fecha.split(/\//).reverse().join('/'));
	    if(cumpleanos.toString() !== 'Invalid Date'){
		    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
		    var m = hoy.getMonth() - cumpleanos.getMonth();

		    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
		        edad--;
		    }
		    if(edad >= 0 && edad < 110){
		    	this.setState({age:edad});	
		    }else{
		    	this.setState({age:'', birthday:''});	
		    	swal('Error', 'Fecha de nacimiento incorrecta', 'error');
		    }
		}else{
			/*control.classList.add('error');
			notify.show('Error, Fecha no válida','error');*/
		}
	}
	selectHandle = (id, name, event, index, value) => {
        this.setState({[event.target.name]:event.target.value});
        if(event.target.name === 'phone_type'){
          this.setState({ext:''});
        }
      }

	  _handleSearchDonor = (query) => {
	    this.setState({isLoading: true});
		fetch(Config.default.apiGateway.URL+'donors?search='+query,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			       'Content-Type': 'application/json',
				}),
				cache:"no-store"
			})
			.then(response => response.json())
			.then(response => {
				if(response !== null){
					for (var i = 0; i < response.length; i++) {
						
						/* revisar en la base de datos el lastname1 y lastname2 ya que lastname1 contiene el lastname2*/

						if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
							response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '
												+response[i].names +' '+ 
												(response[i].birthday !== null ? response[i].birthday : '');
						
						}else{
							response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ 
												(response[i].birthday !== null ? response[i].birthday : '');
						}


						if(response[i].document !== null){							
							response[i].names +=' '+response[i].document_type_value;
							response[i].names +=' '+response[i].document_number;
							
						}
						response[i].id = response[i].donor_id;
					};
					
					this.setState({
						isLoading: false,
				      	optionsDonor: response
				    });
				}
			})
	}
	updateStateDonor(values) {
	    let value = '';
	    if (values.length > 0) {
	      value = values[0];
	    }
	    //this.props.autocompleteHandle('blockFields',false);
	    //this.props.autocompleteHandle('checkEditData',false);
	    
	    this.getInfo(value.id);
	}
	getInfo(id){
		
		 if(id !== "" && id!== undefined){
			return fetch(Config.default.apiGateway.URL+'donors?option=loadDonor&donor_id='+id,{ 
				method: 'get',
				headers: new Headers({
				   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				   'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			})
			.then(response => response.json())
			.then((response) => {
				if(response !== "" && response !== null){
					this.props.waiting.handleClose();
					this.setInfoDonor(response);
				}
			})
		 }
	}
	setInfoDonor(item){
		this.setState({
			names:item.person.names,
			lastname1:item.person.lastname1,
			lastname2:item.person.lastname2!==null?item.person.lastname2:"",
			sex:item.person.sex,
			civil_status:item.person.civil_status,
			scholarship:item.person.scholarship,
			job_profile:item.person.job_profile,
			email:item.person.email,
			birthday:this.formatBirthday(item.person.birthday) ,
			street: item.address !== null? item.address.street:null,
			no_ext: item.address !== null ? item.address.ext_num : "",
			no_int: item.address !== null ? item.address.int_num : "",
			colonia: item.address !== null ? item.address.colonia : "",
			postal_code: item.address !== null? item.address.postal_code:null,
			mpio: item.address !== null? item.address.municipio:null,
			state: item.address !== null? item.address.estado:null,
			person_donor_id:item.person.id,
			address_id: item.address !== null? item.address.id:null,
			phone_type: item.phones.length >0 ? item.phones[0].type:null,
			phone_number : item.phones.length > 0 ? item.phones[0].number:null,
			ext: item.phones.length > 0 ? item.phones[0].extension:null,
			personDonorId:item.person.id
		})
		if(item.document.document !== null && item.document.document !== undefined){
			this.setState({
				document_type:item.document.document.document_type,
				document_number:item.document.document.document_number
			});
		}
		this.donor_data.setJobProfile(this.state.job_profile);
		if(item.address !== null){
			this.setState({
				addressId:item.address.id
			})
			this.address.getMpios(item.address.estado,item.address.municipio);
		}
	}
	formatBirthday =(birthday)=>{
		const date = new Date(birthday);

		const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
			if(formattedDate.length === 10){
				this.calcularEdad(formattedDate);
			}
		return formattedDate;
	}
	//busqueda paciente
	handleSearch = (query) => {
	    this.setState({loading_patient: true});
	    
		fetch(Config.default.apiGateway.URL+'person?search='+query,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
			}),
			cache:'no-cache'
		})
		.then(response => response.json())
		.then(response => {
			if(response !== null){
				for (var i = 0; i < response.length; i++) {
					
					/* revisar en la base de datos el lastname1 y lastname2 ya que lastname1 contiene el lastname2*/

					if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
						response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '
											+response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					
					}else{
						response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					}


					if(response[i].document_type_value !== null){
						response[i].names +=' '+response[i].document_type_value;
					}

					if(response[i].document_number !== null){
						response[i].names +=' '+response[i].document_number;
					}

					if(response[i].number !== null){
						response[i].names += ' '+response[i].number
					}

					if(response[i].social_number !== null){
						response[i].names += ' '+response[i].social_number
					}
					
					response[i].id = response[i].patient_id;
				};
				

				//error
				this.setState({
					loading_patient: false,
			     	patient_list: response,
			     	/*patient_id: "",
			     	person_id: "",
					names: "",
					lastname1: "",
					lastname2: "",
					clinic_history: "",
					disableFields: false,*/
			    });
			}
		})
	}
	getInfoPatient(e){
		if (e.length>0) {
		fetch(Config.default.apiGateway.URL+'patients/patient_offer?id='+e[0].id,{
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					patient_name:response.person.names,
					patient_lastname1:response.person.lastname1,
					patient_lastname2:response.person.lastname2,
					patient_sex: response.person.sex,
					patient_birthday: this.formatBirthday(response.person.birthday),
					personPatientId:response.person.id,
					personAddressId:response.person.address_id
				})
				for (let index = 0; index < this.patient_data.state.rhGroup.length; index++) {
					if (this.patient_data.state.rhGroup[index].key_group == response.person.lookup_group && this.patient_data.state.rhGroup[index].key_rh == response.person.lookup_rh ) {
						this.setState({rh_group:this.patient_data.state.rhGroup[index].name})
					}
					
				}
			}
		})	
		}
		
	}


	handleChangeCompleteDate = (date, hour) => {
		this.setState({ 
			timestamp_date: date,
			timestamp_hour: hour
		});
	};

	render(){
		const { t } = this.props;
		
		return(
			<div>
                <Modal show={this.state.show} onHide={this.handleClose} bsSize="lg" backdrop={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.flagEdit?'Edición de Registro':'Nuevo Registro'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                        <div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
							<div className="col-xs-12" style={{padding:"0px"}}>
								<div className="col-xs-12 col-sm-4">
									<div className="col-xs-4">
										<span>No. de Folio</span>
									</div>
									<div className="col-xs-6">
										<input name="folio" id="folio" value={ this.state.folio } 
											onChange={ this.props.handleChange } type="number" min="1"
											className="form-control" disabled/>
									</div>
								</div>
							</div>
							{this.state.configuredFields.offer.length > 0?
								<div className="col-xs-12">
									<fieldset>
										<legend>Datos de la Donación</legend>
										<DonationData 
											setState={this.setState} 
											state={this.state}
											selectFieldHandle={this.selectFieldHandle}
											extractionTypeSelected={this.extractionTypeSelected}
											donationTypeSelected={this.donationTypeSelected}
											validate={this.validateInput}
											showField={this.showField}
											handleChangeCompleteDate={this.handleChangeCompleteDate}
											{...this.props}
										/>
									</fieldset>
								</div>
							:null}

							<div className="col-xs-12">
								<fieldset>
									<legend>Datos del Donador</legend>
									<div className="col-xs-7">
						 			<span className="span-min">{t('content.generics.buttons.search')}</span>
							        <AsyncTypeahead
							          labelKey={(option) => `${option.names}`}
							          minLength={3}
							          maxLength={50}							          
							          inputProps={{
						          		name:"offer",
						          		id:"offer"
						          	  }}
						          	  id="offer_search"
							          onSearch={this._handleSearchDonor}
							          placeholder="Buscar por apellidos más nombre o número de documento."
							          options={this.state.optionsDonor}
							          onChange={this.updateStateDonor}
							          ref="_handleSearchDonor"
							          useCache={false}
							          isLoading={this.state.isLoading}
							          delay={600}
							          paginationText="Mostrar mas resultados..."
							        />
							 			
								</div>
									<DonorData
										setState={this.setState} 
										state={this.state}
										onRef={ref => (this.donor_data = ref)} 
										selectFieldHandle={this.selectFieldHandle}
										selectHandle = {this.selectHandle}
										validate={this.validateInput}
										autocompleteHandle={this.autocompleteHandle}
										handleChange={this.handleChange}
										showField={this.showField}
										dateHandleChange={this.dateHandleChange}
									/>

									<AddressData
										state={this.state} 
										validate={this.validateInput}
										handleChange={this.handleChange} 
										selectFieldHandle={this.selectFieldHandle} 
										autocompleteHandle={this.autocompleteHandle}
										onRef={ref => (this.address = ref)}
										showField={this.showField}
									/>
								</fieldset>
							</div>

							{this.state.show_patient_data &&
								this.state.configuredFields.patient.length > 0?
									<div className="col-xs-12">
										<fieldset>
											<legend>Datos del Paciente</legend>
											<div className="col-xs-12 col-sm-7">
								<AsyncTypeahead
						          	labelKey={(option) => `${option.names}`}
						          	minLength={0}
						          	options={this.state.patient_list}
						          	onSearch={this.handleSearch}
						          	onChange={this.getInfoPatient}
						          	name="patient_id"
						          	id="patient_id"
						          	isLoading={this.state.loading_patient}
						          	reuired={true}
						          	placeholder="Buscar por apellidos más nombre o número de documento"
						          	ref={ref => this._typeahead = ref}
						          	useCache={false}
						          	delay={800}
						          	paginationText="Mostrar mas resultados..."
						        />
							</div>
											<PatientData
												setState={this.setState} 
												state={this.state}
												selectFieldHandle={this.selectFieldHandle}
												validate={this.validateInput}
												autocompleteHandle={this.autocompleteHandle}
												handleChange={this.handleChange}
												showField={this.showField}
												dateHandleChange={this.dateHandleChange}
												onRef={ref => (this.patient_data = ref)} 
											/>
										</fieldset>
									</div>
							:null}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.save}/>
                        <FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
                    </Modal.Footer>
                </Modal>
	      	</div>
		);
	}
}

export default translate('translations')(ModalNew);